export default "__VITE_ASSET__Bm8RcDTa__"